import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { I18nextProvider } from "react-i18next";
import i18n from "../src/app/i18n";
import { Provider } from "react-redux";
import configureStore from "./app/store";

import { axiosInterceptor } from "./app/config/axiosInterceptor";

const store = configureStore();
axiosInterceptor(store);

ReactDOM.render(
    // <React.StrictMode>
    <Suspense fallback={<div className='main-loader'><img src="/refnext.png" alt="" /><span>処理中。。。</span></div>}>
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                <App />
            </I18nextProvider>
        </Provider>
    </Suspense>,
    // </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// serviceWorker.unregister();